import { FC } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "../redux/store";
import { setPendingMagicLinkAlert } from "../redux/actions/appStatus";
import AlertComponent from "./AlertComponent";

/**
 * Handles showing alerts for magic link edge cases.
 * This component should be placed in App.tsx so it renders on real pages.
 */
const MagicLinkAlertHandler: FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const pendingAlert = useSelector(
        (state: RootState) => state.appStatus.pendingMagicLinkAlert
    );

    const showDifferentUserAlert = pendingAlert === "different-user";

    const onDismiss = () => {
        dispatch(setPendingMagicLinkAlert(null));
    };

    return (
        <AlertComponent
            testId="magic-link-different-user-alert"
            showAlert={showDifferentUserAlert}
            title={t("login.login.magicLinkDifferentUserTitle")}
            description={t("login.login.magicLinkDifferentUserMessage")}
            buttonDone={t("help.OnboardingVideo.controls.ok")}
            dismissAlert={onDismiss}
            onDonePressed={onDismiss}
        />
    );
};

export default MagicLinkAlertHandler;
